import React, { useEffect }from 'react';
import { Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

//import Navbar from 'components/CoreContainers/Navbar';
//import Footer from 'components/CoreContainers/Footer';
import Sidebar from 'components/CoreContainers/Sidebar';

import styles from 'assets/jss/material-dashboard-react/layouts/adminStyle.js';

let ps;

const useStyles = makeStyles(styles);

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  authToken: state.authToken
});

const Admin = ({ activeUserId, activeUserType, authToken, ...rest }) => {
  const classes = useStyles();

  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();

  //const [color, setColor] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  /*
  const handleColorClick = (color) => {
    setColor(color);
  };*/

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  // initialize and destroy the PerfectScrollbar plugin
  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  
  }, [mainPanel]);

  return (
    <div className={classes.wrapper}>
      <Sidebar
        open={mobileOpen}
        color={"blue"}
        logoText={"DUOT KHAYAT"}
        image={null}
        activeUserId={activeUserId}
        activeUserType={activeUserType}
        authToken={authToken}
        handleDrawerToggle={handleDrawerToggle}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        {/*<Navbar
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        On the /maps route we want the map to be on full screen - this is not possible if the content and container classes are present because they have some paddings which would make the map smaller */}

          <div className={classes.content}>
            <div className={classes.container}>
              <Outlet />
            </div>
          </div>
        {/*<Footer />*/}
      </div>
    </div>
  )
};

export default connect (mapStateToProps) (Admin);